import { render, staticRenderFns } from "./krwManagement.vue?vue&type=template&id=16a23a1e&scoped=true&"
import script from "./krwManagement.vue?vue&type=script&lang=js&"
export * from "./krwManagement.vue?vue&type=script&lang=js&"
import style0 from "./krwManagement.vue?vue&type=style&index=0&id=16a23a1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a23a1e",
  null
  
)

export default component.exports